import gql from 'not-graphql-tag';

export const updatePinMutation = gql`
  mutation updatePin($payload: ChangePinUpdateRequest!) {
    updatePin(payload: $payload) {
      success
    }
  }
`;
